//
// PickEntryType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var PickEntryType = {
    CROSSTAB_ROW_HEADER:0,
    CROSSTAB_MEASURE_HEADER:1,
    CROSSTAB_COLUMN_HEADER:2,
    CROSSTAB_ROW_AXIS_LABEL_HEADER:3,
    CROSSTAB_COLUMN_AXIS_LABEL_HEADER:4,
    CROSSTAB_DATA_CELL:5,
    DATAGRID_DATA_CELL:6,
    DATAGRID_COLUMN_HEADER:7,
    DATAGRID_COLUMN_SEPARATOR:8,
    DATAGRID_COLUMN_TOTAL:9
};
export default PickEntryType;
